import React from 'react';

export const HowItWorksSteps = () => {
  return (
    <>
      {/* Frame 1 */}
      <div style={{ position: 'absolute', width: 319, height: 351, left: 192, top: 1037 }}>
        <div
          style={{
            position: 'absolute',
            width: 319,
            height: 279,
            left: 0,
            top: 54,
            background: 'rgba(127, 56, 243, 0.15)',
            backgroundBlendMode: 'plus-lighter',
            mixBlendMode: 'normal',
            boxShadow: `-11.1504px -10.392px 48px -12px rgba(0,0,0,0.15),
              -1.8584px -1.732px 12px -8px rgba(0,0,0,0.15),
              inset 2.00707px 1.87056px 8.64px rgba(255,255,255,0.15),
              inset 1.07787px 1.00456px 4.32px rgba(255,255,255,0.15)`,
            backdropFilter: 'blur(4.88px)',
            borderRadius: 50,
          }}
        >
          <div
            style={{
              position: 'absolute',
              width: 270,
              height: 48,
              left: 28,
              top: 86,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 36,
              lineHeight: '48px',
              textAlign: 'center',
              color: '#FFFFFF',
            }}
          >
            1. Upload Chart
          </div>
          <div
            style={{
              position: 'absolute',
              width: 259,
              height: 141,
              left: 30,
              top: 140,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 24,
              lineHeight: '29px',
              textAlign: 'center',
              color: 'rgba(255, 255, 255, 0.6)',
            }}
          >
            Upload your trading chart screenshot or image from any platform
          </div>
        </div>

        {/* Ellipse + SVG */}
        <div
          style={{
            position: 'absolute',
            width: 128,
            height: 128,
            left: 96,
            top: 0,
            background: 'rgba(96, 13, 219, 0.2)',
            backgroundBlendMode: 'plus-lighter',
            mixBlendMode: 'normal',
            boxShadow: `-11.1504px -10.392px 48px -12px rgba(0,0,0,0.15),
              -1.8584px -1.732px 12px -8px rgba(0,0,0,0.15),
              inset 2.14645px 2.00046px 9.24px rgba(255,255,255,0.126),
              inset 1.21725px 1.13446px 4.62px rgba(255,255,255,0.126)`,
            backdropFilter: 'blur(7.58px)',
            borderRadius: '50%',
          }}
        >
          <svg
            width="66"
            height="71"
            viewBox="0 0 66 71"
            fill="none"
            style={{ position: 'absolute', left: 31, top: 26 }}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M37.7143 16.0106V46.8749C37.7143 49.4677 35.6076 51.5624 33 51.5624C30.3924 51.5624 28.2857 49.4677 28.2857 46.8749V16.0106L22.1866 22.0751C20.3451 23.9061 17.3545 23.9061 15.5129 22.0751C13.6714 20.244 13.6714 17.2704 15.5129 15.4393L29.6558 1.37683C31.4973 -0.454224 34.4879 -0.454224 36.3295 1.37683L50.4723 15.4393C52.3138 17.2704 52.3138 20.244 50.4723 22.0751C48.6308 23.9061 45.6402 23.9061 43.7987 22.0751L37.7143 16.0106ZM33 58.5936C39.5116 58.5936 44.7857 53.3495 44.7857 46.8749H56.5714C61.7719 46.8749 66 51.079 66 56.2499V60.9374C66 66.1083 61.7719 70.3124 56.5714 70.3124H9.42857C4.22813 70.3124 0 66.1083 0 60.9374V56.2499C0 51.079 4.22813 46.8749 9.42857 46.8749H21.2143C21.2143 53.3495 26.4884 58.5936 33 58.5936ZM54.2143 62.1093C54.6786 62.1093 55.1384 62.0183 55.5673 61.8416C55.9963 61.665 56.3861 61.406 56.7144 61.0795C57.0427 60.7531 57.3032 60.3655 57.4809 59.939C57.6585 59.5125 57.75 59.0553 57.75 58.5936C57.75 58.132 57.6585 57.6748 57.4809 57.2483C57.3032 56.8217 57.0427 56.4342 56.7144 56.1077C56.3861 55.7813 55.9963 55.5223 55.5673 55.3456C55.1384 55.1689 54.6786 55.078 54.2143 55.078C53.75 55.078 53.2902 55.1689 52.8612 55.3456C52.4323 55.5223 52.0425 55.7813 51.7142 56.1077C51.3858 56.4342 51.1254 56.8217 50.9477 57.2483C50.77 57.6748 50.6786 58.132 50.6786 58.5936C50.6786 59.0553 50.77 59.5125 50.9477 59.939C51.1254 60.3655 51.3858 60.7531 51.7142 61.0795C52.0425 61.406 52.4323 61.665 52.8612 61.8416C53.2902 62.0183 53.75 62.1093 54.2143 62.1093Z"
              fill="url(#paint0_linear_2_53)"
            />
            <defs>
              <linearGradient id="paint0_linear_2_53" x1="0" y1="35.158" x2="66" y2="35.158" gradientUnits="userSpaceOnUse">
                <stop stopColor="#6D1D7D" />
                <stop offset="1" stopColor="#5F0BE8" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>

      {/* Frame 2 */}
      <div style={{ position: 'absolute', width: 319, height: 351, left: 560, top: 1037 }}>
        <div
          style={{
            position: 'absolute',
            width: 319,
            height: 279,
            left: 0,
            top: 54,
            background: 'rgba(127, 56, 243, 0.15)',
            backgroundBlendMode: 'plus-lighter',
            mixBlendMode: 'normal',
            boxShadow: `-11.1504px -10.392px 48px -12px rgba(0,0,0,0.15),
              -1.8584px -1.732px 12px -8px rgba(0,0,0,0.15),
              inset 2.00707px 1.87056px 8.64px rgba(255,255,255,0.15),
              inset 1.07787px 1.00456px 4.32px rgba(255,255,255,0.15)`,
            backdropFilter: 'blur(4.88px)',
            borderRadius: 50,
          }}
        >
          <div
            style={{
              position: 'absolute',
              width: 219,
              height: 48,
              left: 48,
              top: 86,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 36,
              lineHeight: '48px',
              textAlign: 'center',
              color: '#FFFFFF',
            }}
          >
            2. AI Analysis
          </div>
          <div
            style={{
              position: 'absolute',
              width: 259,
              height: 141,
              left: 30,
              top: 140,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 24,
              lineHeight: '29px',
              textAlign: 'center',
              color: 'rgba(255, 255, 255, 0.6)',
            }}
          >
            Our AI analyzes patterns, levels, and market structure instantly
          </div>
        </div>
        <div
          style={{
            position: 'absolute',
            width: 128,
            height: 128,
            left: 96,
            top: 0,
            background: 'rgba(96, 13, 219, 0.2)',
            backgroundBlendMode: 'plus-lighter',
            mixBlendMode: 'normal',
            boxShadow: `-11.1504px -10.392px 48px -12px rgba(0,0,0,0.15),
              -1.8584px -1.732px 12px -8px rgba(0,0,0,0.15),
              inset 2.14645px 2.00046px 9.24px rgba(255,255,255,0.126),
              inset 1.21725px 1.13446px 4.62px rgba(255,255,255,0.126)`,
            backdropFilter: 'blur(7.58px)',
            borderRadius: '50%',
          }}
        >
          <svg
            width="71"
            height="67"
            viewBox="0 0 71 67"
            fill="none"
            style={{ position: 'absolute', left: 23, top: 23 }}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M67.8775 38.1092C68.185 43.405 65.7592 48.4958 61.42 51.605L64.0508 56.6958C64.8367 58.2333 64.9392 60.0442 64.2558 61.65C63.6067 63.2558 62.2742 64.52 60.6342 65.0667L57.935 65.9208C56.811 66.298 55.5981 66.3199 54.4611 65.9837C53.3241 65.6475 52.3182 64.9695 51.58 64.0417L44.3367 55.5C41.2958 54.9875 38.4258 53.6892 36 51.7417C34.2917 52.2542 32.5833 52.5275 30.875 52.5275C27.8683 52.5275 24.8617 51.605 22.3333 49.8283C20.5225 50.375 18.6775 50.6142 16.7983 50.58C14.0992 50.6142 11.4342 50.0675 8.94001 49.0425C6.53804 47.973 4.48557 46.249 3.01734 44.0678C1.54911 41.8866 0.724391 39.3362 0.637512 36.7083C0.364179 34.2483 0.774179 31.7542 1.83335 29.4992C0.842512 26.9367 0.740012 24.135 1.59418 21.5383C2.85835 18.2925 5.25001 15.5933 8.22251 13.885C10.2042 8.11084 15.7733 4.25 21.8892 4.66C27.3558 -0.465 35.7267 -1.01167 41.8083 3.39583C43.2433 3.02 44.7467 2.815 46.25 2.815C50.8967 2.7125 55.3042 4.7625 58.2083 8.41833C65.1783 10.2292 70.1667 16.4475 70.44 23.6908C70.6108 27.4833 69.5858 31.2075 67.5017 34.385C67.7408 35.615 67.8775 36.845 67.8775 38.1092ZM50.7942 33.2917C52.7417 33.5308 54.2792 35 54.2792 36.9475C54.2792 37.8537 53.9192 38.7227 53.2785 39.3634C52.6377 40.0042 51.7687 40.3642 50.8625 40.3642H48.71C47.6167 43.4392 45.7033 46.1383 43.175 48.1883C44.0292 48.4958 44.9175 48.6667 45.8058 48.9058C63.3333 48.6667 61.2833 37.9725 61.2833 37.8017C61.2393 36.6393 60.9666 35.497 60.4807 34.4402C59.9948 33.3833 59.3054 32.4326 58.4517 31.6424C57.5981 30.8523 56.5971 30.2382 55.5059 29.8352C54.4147 29.4323 53.2548 29.2484 52.0925 29.2942C51.1864 29.2942 50.3173 28.9342 49.6766 28.2934C49.0358 27.6527 48.6758 26.7837 48.6758 25.8775C48.6758 24.9713 49.0358 24.1023 49.6766 23.4616C50.3173 22.8208 51.1864 22.4608 52.0925 22.4608C56.295 22.5633 60.3267 24.135 63.47 26.9025C63.6409 25.9117 63.7434 24.8867 63.7434 23.8617C63.5383 19.625 61.625 15.935 53.9375 15.2175C49.6667 5.10417 38.9042 10.7075 38.9042 13.8508C38.8017 14.6367 39.6217 16.3108 39.7583 16.4133C40.6645 16.4133 41.5335 16.7733 42.1743 17.4141C42.815 18.0548 43.175 18.9238 43.175 19.83C43.175 21.7092 41.6375 23.2467 39.7583 23.2467C37.9475 23.1783 36.2392 22.495 34.8725 21.3333C33.2325 22.3925 31.3533 23.0417 29.4058 23.2467C27.4583 23.4175 25.8525 22.0508 25.75 20.1717C25.6881 19.7255 25.7177 19.2714 25.8372 18.8371C25.9567 18.4028 26.1634 17.9974 26.4448 17.6456C26.7262 17.2939 27.0763 17.0032 27.4738 16.7913C27.8713 16.5795 28.3078 16.4508 28.7567 16.4133C29.3033 16.345 31.9683 15.935 31.9683 13.7825C31.9683 11.5275 32.8225 9.375 34.2917 7.66667C31.1483 6.8125 27.7658 7.94 24.3492 12.0742C18.0625 11.0833 15.5 11.9375 13.6208 18.6C10.375 20.2058 8.66668 21.3333 7.91501 24.75C11.605 23.9983 15.3975 24.3058 18.9167 25.6042C20.625 26.2533 21.5817 28.1667 20.9325 30.0117C20.2833 31.7883 18.3017 32.6767 16.525 32.0275C14.0308 30.9342 11.2292 30.8658 8.66668 31.8225C7.57335 32.745 7.57335 34.6583 7.57335 36.1617C7.57335 38.69 8.83751 41.0475 10.99 42.4142C12.8008 43.3367 14.8167 43.815 16.8325 43.7808C16.32 42.8925 15.8758 41.97 15.5 41.0133C15.231 40.1355 15.313 39.1876 15.7286 38.3689C16.1442 37.5503 16.8611 36.9247 17.7285 36.6237C18.5958 36.3228 19.5461 36.37 20.3795 36.7553C21.2128 37.1407 21.8642 37.8342 22.1967 38.69C23.5633 42.585 27.0483 45.25 31.1483 45.6942C35.8292 45.455 39.9975 42.6875 42.0475 38.4167C42.8333 33.7017 46.6258 33.2917 50.7942 33.2917ZM57.6275 58.8142L55.5092 54.3725L53.0833 54.9192L56.5 59.19L57.6275 58.8142ZM41.74 29.3967C41.7697 28.5238 41.4641 27.6728 40.8858 27.0183C40.3076 26.3638 39.5007 25.9556 38.6308 25.8775C36.205 25.7408 33.8475 26.5608 32.0367 28.1667C30.0892 30.1483 29.0642 32.8817 29.1667 35.6492C29.1667 36.5553 29.5266 37.4244 30.1674 38.0651C30.8081 38.7059 31.6772 39.0658 32.5833 39.0658C34.5308 39.0658 36 37.5283 36 35.6492C36 34.7267 36.2392 33.8042 36.7858 33.0525C37.1958 32.7108 37.7083 32.54 38.255 32.54C40.1342 32.6425 41.74 31.2417 41.74 29.3967Z"
              fill="url(#paint0_linear_2_80)"
            />
            <defs>
              <linearGradient id="paint0_linear_2_80" x1="0.555237" y1="33.3209" x2="70.4584" y2="33.3209" gradientUnits="userSpaceOnUse">
                <stop stopColor="#6D1D7D" />
                <stop offset="1" stopColor="#5F0BE8" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>

      {/* Frame 3 */}
      <div style={{ position: 'absolute', width: 319, height: 351, left: 928, top: 1037 }}>
        <div
          style={{
            position: 'absolute',
            width: 319,
            height: 279,
            left: 0,
            top: 54,
            background: 'rgba(127, 56, 243, 0.15)',
            backgroundBlendMode: 'plus-lighter',
            mixBlendMode: 'normal',
            boxShadow: `-11.1504px -10.392px 48px -12px rgba(0,0,0,0.15),
              -1.8584px -1.732px 12px -8px rgba(0,0,0,0.15),
              inset 2.00707px 1.87056px 8.64px rgba(255,255,255,0.15),
              inset 1.07787px 1.00456px 4.32px rgba(255,255,255,0.15)`,
            backdropFilter: 'blur(4.88px)',
            borderRadius: 50,
          }}
        >
          <div
            style={{
              position: 'absolute',
              width: 219,
              height: 48,
              left: 48,
              top: 86,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 36,
              lineHeight: '48px',
              textAlign: 'center',
              color: '#FFFFFF',
            }}
          >
            3. Trade Plan
          </div>
          <div
            style={{
              position: 'absolute',
              width: 259,
              height: 141,
              left: 30,
              top: 140,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 24,
              lineHeight: '29px',
              textAlign: 'center',
              color: 'rgba(255, 255, 255, 0.6)',
            }}
          >
            Get actionable insights with entry, stop loss, and take profit levels
          </div>
        </div>
        <div
          style={{
            position: 'absolute',
            width: 128,
            height: 128,
            left: 96,
            top: 0,
            background: 'rgba(96, 13, 219, 0.2)',
            backgroundBlendMode: 'plus-lighter',
            mixBlendMode: 'normal',
            boxShadow: `-11.1504px -10.392px 48px -12px rgba(0,0,0,0.15),
              -1.8584px -1.732px 12px -8px rgba(0,0,0,0.15),
              inset 2.14645px 2.00046px 9.24px rgba(255,255,255,0.126),
              inset 1.21725px 1.13446px 4.62px rgba(255,255,255,0.126)`,
            backdropFilter: 'blur(7.58px)',
            borderRadius: '50%',
          }}
        >
          <svg
            width="76"
            height="70"
            viewBox="0 0 76 70"
            fill="none"
            style={{ position: 'absolute', left: 21, top: 21 }}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M76.0078 39.8203C76.0078 40.877 75.588 41.8905 74.8408 42.6377C74.0936 43.3849 73.0802 43.8047 72.0234 43.8047C70.9667 43.8047 69.9533 43.3849 69.2061 42.6377C68.4588 41.8905 68.0391 40.877 68.0391 39.8203C68.0294 31.5456 64.738 23.6126 58.8869 17.7615C53.0358 11.9104 45.1028 8.61904 36.8281 8.60938C29.4335 8.61729 22.344 11.5583 17.1152 16.7871C11.8864 22.0159 8.94541 29.1054 8.9375 36.5C8.94541 43.014 11.5366 49.259 16.1427 53.8651C20.7488 58.4712 26.9938 61.0624 33.5078 61.0703C39.1418 61.0642 44.5432 58.8234 48.527 54.8395C52.5109 50.8557 54.7517 45.4543 54.7578 39.8203C54.7525 35.0667 52.8618 30.5093 49.5005 27.1479C46.1392 23.7866 41.5818 21.8959 36.8281 21.8906C32.9548 21.895 29.2414 23.4356 26.5026 26.1745C23.7638 28.9133 22.2231 32.6267 22.2188 36.5C22.2188 39.494 23.4081 42.3655 25.5252 44.4826C27.6423 46.5997 30.5138 47.7891 33.5078 47.7891C35.6213 47.7891 37.6481 46.9495 39.1426 45.4551C40.637 43.9606 41.4766 41.9338 41.4766 39.8203C41.4766 38.5875 40.9868 37.4051 40.1151 36.5334C39.2433 35.6616 38.061 35.1719 36.8281 35.1719C36.4769 35.1725 36.1403 35.3122 35.8918 35.5604C36.7078 35.9498 37.3671 36.6052 37.7614 37.4188C38.1557 38.2325 38.2614 39.1561 38.0614 40.0379C37.8613 40.9196 37.3673 41.7071 36.6605 42.271C35.9536 42.8348 35.076 43.1415 34.1719 43.1406C32.4107 43.1406 30.7216 42.441 29.4762 41.1956C28.2309 39.9503 27.5312 38.2612 27.5312 36.5C27.5312 34.0343 28.5107 31.6696 30.2542 29.9261C31.9977 28.1826 34.3624 27.2031 36.8281 27.2031C38.485 27.2031 40.1257 27.5295 41.6565 28.1636C43.1873 28.7976 44.5782 29.727 45.7498 30.8986C46.9214 32.0702 47.8508 33.4611 48.4849 34.9919C49.119 36.5227 49.4453 38.1634 49.4453 39.8203C49.4409 44.0459 47.7604 48.0971 44.7725 51.085C41.7846 54.0729 37.7334 55.7534 33.5078 55.7578C28.4022 55.7517 23.5075 53.7207 19.8973 50.1105C16.2871 46.5003 14.2562 41.6056 14.25 36.5C14.2562 30.5138 16.6369 24.7745 20.8698 20.5416C25.1027 16.3088 30.8419 13.928 36.8281 13.9219C43.6944 13.9298 50.2772 16.6609 55.1324 21.5161C59.9875 26.3713 62.7187 32.954 62.7266 39.8203C62.7178 47.5669 59.6366 54.9937 54.1589 60.4714C48.6812 65.9491 41.2544 69.0303 33.5078 69.0391C24.8809 69.0294 16.6101 65.5981 10.5099 59.4979C4.40973 53.3978 0.978417 45.1269 0.96875 36.5C0.979296 26.9927 4.76071 17.8779 11.4834 11.1552C18.206 4.43259 27.3209 0.651171 36.8281 0.640625C47.2157 0.65205 57.1746 4.78357 64.5197 12.1287C71.8649 19.4739 75.9964 29.4327 76.0078 39.8203Z"
              fill="url(#paint0_linear_2_82)"
            />
            <defs>
              <linearGradient id="paint0_linear_2_82" x1="0.96875" y1="34.8398" x2="76.0078" y2="34.8398" gradientUnits="userSpaceOnUse">
                <stop stopColor="#6D1D7D" />
                <stop offset="1" stopColor="#5F0BE8" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </>
  );
};